(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DiseaseType', DiseaseType);

    DiseaseType.$inject = ['$resource'];

    function DiseaseType ($resource) {
        var resourceUrl =  'api/disease-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
